import { Component } from 'inferno'
import './style.css'

const GalaxyIcon = props => (
    <svg viewBox="0 0 168 156" {...props} className='galaxy-icon'>
        <path d="M0 89c0-39.4 31.6-77 74-77 33.8 0 61 23.2 61 58 0 20.8-16.2 44-41 44-22 0-34-14-34-31-3.6 0-6 6-6 12 0 16.6 19.8 34 43 34 30.4 0 62-27.8 62-69 0-25.6-12.4-47-23-60 13 11 32 32.8 32 67 0 39.4-31.6 77-74 77-33.8 0-61-23.2-61-58 0-20.8 16.2-44 41-44 22 0 34 14 34 31 3.6 0 6-6 6-12 0-16.6-19.8-34-43-34C40.6 27 9 54.8 9 96c0 25.6 12.4 47 23 60-13-11-32-32.8-32-67z" />
    </svg>
);

export default GalaxyIcon;


// WEBPACK FOOTER //
// ./src/experiments/Galaxy/assets/icons/GalaxyIcon/index.js